import { TaskDetailsPageHeader, TaskDetailsForm } from "./components";
import { useParams } from "react-router-dom";
import SubTasksList from "../SubTasksList";
import { useEffect, useState } from "react";
import { PriorityOptions, StatusOptions } from "@type/taskManagement/common";
import { useStatusList } from "@hooks/taskManagement/settings/status/useStatusList";
import { StatusResponseType } from "@type/taskManagement/settings/status";
import { usePriorityList } from "@hooks/taskManagement/settings/priority/usePriorityList";
import { PriorityResponseType } from "@type/taskManagement/settings/priority";

export default function TaskDetails() {
  const { id } = useParams();

  const [statusOptions, setStatusOptions] = useState<StatusOptions>([]);
  const [priorityOptions, setPriorityOptions] = useState<PriorityOptions>([]);

  const { statusState } = useStatusList();
  const { getData: statusGetData } = statusState;
  const { data: statusData } = statusGetData || ({} as StatusResponseType);

  const { priorityState } = usePriorityList();
  const { getData: priorityGetData } = priorityState;

  const { data: priorityData } =
    priorityGetData || ({} as PriorityResponseType);

  useEffect(() => {
    if (statusData) {
      const status = statusData.map((item: any) => ({
        label: item?.name,
        value: `${item?.id}`,
      }));

      setStatusOptions((prev) => status);
    }
  }, [statusGetData]);

  useEffect(() => {
    if (priorityData) {
      const priority = priorityData.map((item: any) => ({
        label: item?.name,
        value: `${item?.id}`,
      }));

      setPriorityOptions((prev) => priority);
    }
  }, [priorityGetData]);

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <TaskDetailsPageHeader />
      <TaskDetailsForm
        statusOptions={statusOptions}
        priorityOptions={priorityOptions}
      />

      {id && (
        <SubTasksList
          statusOptions={[{ label: "All", value: "all" }, ...statusOptions]}
        />
      )}
    </div>
  );
}
